import { Box, Text, Flex } from "@chakra-ui/react";
import React from "react";
import { Sport } from "../data/api";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

type Props = {
  countdown: number;
};

const LiveAlert = ({ countdown }: Props) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      p={3}
      gap={2}
      mb={3}
      w="full"
      rounded="md"
    >
      <Flex alignItems="center" gap={2}>
        <MotionBox
          bg="red.500"
          w={5}
          h={5}
          rounded="full"
          animate={{ opacity: 0 }}
          transition={{
            ease: "linear",
            repeat: Infinity,
            repeatType: "reverse",
            duration: 1,
          }}
        />
        <Text fontWeight={"bold"}>LIVE UPDATES</Text>
      </Flex>
      <Text fontSize="sm" opacity={0.5}>
        Refreshing in {countdown}s
      </Text>
    </Flex>
  );
};

export default LiveAlert;
